// SEP 911 — Catálogos oficiales compartidos (frontend)
// Mantén sincronizado con /app/backend/server.py SEP_NIVEL_EDUCATIVO / FUNCION_PERSONAL.

// 22 niveles educativos oficiales del formato 911 (secciones 12-13)
export const NIVEL_EDUCATIVO_911 = [
  { value: "PRIMARIA_INCOMPLETA", label: "Primaria incompleta" },
  { value: "PRIMARIA_TERMINADA", label: "Primaria terminada" },
  { value: "SECUNDARIA_INCOMPLETA", label: "Secundaria incompleta" },
  { value: "SECUNDARIA_TERMINADA", label: "Secundaria terminada" },
  { value: "PROFESIONAL_TECNICO", label: "Profesional técnico" },
  { value: "BACHILLERATO_INCOMPLETO", label: "Bachillerato incompleto" },
  { value: "BACHILLERATO_TERMINADO", label: "Bachillerato terminado" },
  { value: "NORMAL_PREESCOLAR_INCOMPLETA", label: "Normal preescolar incompleta" },
  { value: "NORMAL_PREESCOLAR_TERMINADA", label: "Normal preescolar terminada" },
  { value: "NORMAL_PRIMARIA_INCOMPLETA", label: "Normal primaria incompleta" },
  { value: "NORMAL_PRIMARIA_TERMINADA", label: "Normal primaria terminada" },
  { value: "NORMAL_SUPERIOR_INCOMPLETA", label: "Normal superior incompleta" },
  { value: "NORMAL_SUPERIOR_PASANTE", label: "Normal superior pasante" },
  { value: "NORMAL_SUPERIOR_TITULADO", label: "Normal superior titulado" },
  { value: "LICENCIATURA_INCOMPLETA", label: "Licenciatura incompleta" },
  { value: "LICENCIATURA_PASANTE", label: "Licenciatura pasante" },
  { value: "LICENCIATURA_TITULADO", label: "Licenciatura titulado" },
  { value: "MAESTRIA_INCOMPLETA", label: "Maestría incompleta" },
  { value: "MAESTRIA_GRADUADO", label: "Maestría graduado" },
  { value: "DOCTORADO_INCOMPLETO", label: "Doctorado incompleto" },
  { value: "DOCTORADO_GRADUADO", label: "Doctorado graduado" },
  { value: "OTROS", label: "Otros (especifique)" },
];

// Funciones oficiales del formato 911 (secciones 12, 13 y 14 del PDF).
// Los subdirectores van al inicio por solicitud del usuario.
export const FUNCION_PERSONAL_911 = [
  { value: "SUBDIRECTOR_GESTION_ESCOLAR", label: "Subdirector de Gestión Escolar", grupo: "Directivo" },
  { value: "SUBDIRECTOR_ACADEMICO", label: "Subdirector Académico", grupo: "Directivo" },
  { value: "PROFESOR_EDUCACION_FISICA", label: "Profesor de Educación Física", grupo: "Docente especial" },
  { value: "PROFESOR_ARTISTICAS", label: "Profesor de Actividades Artísticas", grupo: "Docente especial" },
  { value: "PROFESOR_TECNOLOGICAS", label: "Profesor de Actividades Tecnológicas", grupo: "Docente especial" },
  { value: "PROFESOR_IDIOMAS", label: "Profesor de Idiomas", grupo: "Docente especial" },
  { value: "MAESTRO_TALLER_LECTURA", label: "Maestro de taller de lectura y escritura", grupo: "Administrativo" },
  { value: "PROMOTOR_TIC", label: "Promotor de TIC", grupo: "Administrativo" },
  { value: "INTENDENTE", label: "Intendente", grupo: "Administrativo" },
  { value: "CONSERJE", label: "Conserje", grupo: "Administrativo" },
  { value: "COCINERA", label: "Cocinera", grupo: "Administrativo" },
  { value: "AUX_COCINA", label: "Auxiliar de cocina", grupo: "Administrativo" },
  { value: "VELADOR", label: "Velador", grupo: "Administrativo" },
  { value: "APOYO_ADMINISTRATIVO", label: "Apoyo administrativo", grupo: "Administrativo" },
  { value: "ADMINISTRADOR", label: "Administrador", grupo: "Administrativo" },
  { value: "PREFECTO", label: "Prefecto", grupo: "Administrativo" },
  { value: "PREFECTO_NOCTURNO", label: "Prefecto nocturno", grupo: "Administrativo" },
  { value: "PSICOLOGO", label: "Psicólogo", grupo: "Administrativo" },
  { value: "SECRETARIA", label: "Secretaría", grupo: "Administrativo" },
  { value: "MEDICO", label: "Médico", grupo: "Administrativo" },
  { value: "DENTISTA", label: "Dentista", grupo: "Administrativo" },
  { value: "TRABAJADORA_SOCIAL", label: "Trabajadora social", grupo: "Administrativo" },
  { value: "CONTRALOR", label: "Responsable de fondos / Contralor", grupo: "Administrativo" },
  { value: "ALMACENISTA", label: "Almacenista", grupo: "Administrativo" },
  { value: "ENFERMERA", label: "Enfermera", grupo: "Administrativo" },
  { value: "JEFE_OFICINA", label: "Jefe de oficina", grupo: "Administrativo" },
  { value: "ANALISTA_ADMIN", label: "Analista administrativo", grupo: "Administrativo" },
  { value: "TERAPISTA", label: "Terapeuta", grupo: "Administrativo" },
  { value: "ESPECIALISTA_TECNICO", label: "Especialista técnico", grupo: "Administrativo" },
  { value: "JEFE_SERVICIOS", label: "Jefe de servicios y mantenimiento", grupo: "Administrativo" },
  { value: "OTROS", label: "Otros (especifique)", grupo: "Administrativo" },
];

export const labelNivel = (v) => NIVEL_EDUCATIVO_911.find((n) => n.value === v)?.label || v || "—";
export const labelFuncion = (v) => FUNCION_PERSONAL_911.find((f) => f.value === v)?.label || v || "—";
